<template>
  <v-card-text>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="editedItem.name"
          label="Название"></v-text-field>
        <v-textarea
          v-model="editedItem.description"
          label="Описание"></v-textarea>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'FormCommon',
  props: {
    editedItem: Object
  }
}
</script>

<style scoped>

</style>
